var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "loader",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ],
      attrs: { "is-loading": _vm.isLoading }
    },
    [
      _c(
        "div",
        [
          _c(
            "v-list-item",
            { staticClass: "px-0", attrs: { "two-line": "" } },
            [
              _c(
                "v-list-item-avatar",
                { staticClass: "mt-2" },
                [
                  _c("v-icon", { attrs: { color: "primary", large: "" } }, [
                    _vm._v(_vm._s(_vm.icon))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item-content",
                [
                  _c("v-list-item-title", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-space-between font-weight-bold"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.title ||
                                _vm.generateMessage("boilerplate.filters.title")
                            ) +
                            "\n            "
                        ),
                        _vm._t("action-title")
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-list-item-subtitle",
                    [
                      _c("truncate-text-with-hover", {
                        staticClass: "font-classic",
                        attrs: { text: _vm.subtitle, length: 25 }
                      }),
                      _vm._v(" "),
                      _vm._t("subtitle")
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.resetBtn
            ? _c(
                "v-btn",
                {
                  staticClass: "text-none my-2",
                  attrs: { block: "", color: "primary", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.resetFilters()
                    }
                  }
                },
                [
                  _c("v-icon", [
                    _vm._v(
                      _vm._s(_vm.generateMessage("boilerplate.icons.refresh"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-decoration-underline" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.generateMessage("boilerplate.filters.reset")
                        ) +
                        "\n      "
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.namespace && _vm.isPagination
            ? _c("custom-page-selector", {
                attrs: { namespace: _vm.namespace }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isSearch
            ? _c("v-text-field", {
                staticClass: "my-2",
                attrs: {
                  label: _vm.generateMessage("boilerplate.filters.search"),
                  outlined: "",
                  dense: "",
                  clearable: "",
                  "prepend-inner-icon": "mdi-magnify"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "append",
                      fn: function() {
                        return [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                "close-on-content-click": false,
                                transition: "scale-transition"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function({ on }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                "x-small": "",
                                                icon: "",
                                                outlined: ""
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.generateMessage(
                                                      "boilerplate.filters.icons.infos"
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2314061315
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("div", { staticClass: "background pa-2" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.generateMessage(
                                        "boilerplate.filters.searchIn"
                                      )
                                    ) +
                                    "\n            "
                                ),
                                _c(
                                  "ul",
                                  _vm._l(_vm.searchFields, function(field) {
                                    return _c("li", { key: field }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.generateMessage(
                                              `${_vm.i18nPath ||
                                                _vm.namespace}.fields.${field}`
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ])
                                  }),
                                  0
                                )
                              ])
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  4030646296
                ),
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "search"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDateFilter && _vm.namespace
            ? _c(
                "div",
                { staticStyle: { height: "36px" } },
                [
                  _c("filter-by-date", {
                    attrs: {
                      block: "",
                      text: "",
                      type: "datetime-local",
                      namespace: _vm.namespace
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mb-3" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "overflow-y-auto overflow-x-hidden mt-2",
          style: `height: ${_vm.height}px`
        },
        [_vm._t("content")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }